export default __webpack_public_path__ + "2a0c062c3f50cdfb43f8a90f0c7da78c.png";